import React from 'react';
import Button from 'web/components/Button';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './yesNoModal.scss';

export default ({ isOpen, toggle, content, onClickHander, confirmationComment = '', setconfirmationComment = () => { }, ...props }) => {

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='next-step-modal'>
        <div className='modal-content'>
          <ModalBody>
            <div className='modal-content text-left content-style'>
              <p className='mt-4 mb-2' >{content}</p>
            </div>
            <div className="app-input-text text-left" style={{ width: "100%" }}>
              {props.showCommentText && <span>Comment</span>}
              <textarea
                name='comment'
                maxLength='200'
                showErrorMessages={true}
                value={confirmationComment}
                onChange={e => setconfirmationComment(e.target.value)}
                className="text-left"
              />
            </div>
          </ModalBody>
          <div className='modal-footer-style'>
            <Button
              type='cancel-button'
              handleClick={() => {
                toggle(!isOpen)
                onClickHander('no')
              }}>
              Cancel
            </Button>
            <Button
              type='submit-button'
              handleClick={() => {
                onClickHander()
              }}>
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
